import { render, staticRenderFns } from "./AsideNav.vue?vue&type=template&id=f23ac5ae&scoped=true"
import script from "./AsideNav.vue?vue&type=script&lang=js"
export * from "./AsideNav.vue?vue&type=script&lang=js"
import style0 from "./AsideNav.vue?vue&type=style&index=0&id=f23ac5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23ac5ae",
  null
  
)

export default component.exports